import styled from 'styled-components'
import { maxXs, minXs } from '../../styles/breakPoints'
import background2 from './img/background-2.png'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  top: 0px;
  left: 0px;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 0 0 auto;

  .headline-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    margin-top: 50px;
    display: flex;
    justify-content: center;

    div {
      display: flex;
      flex-direction: column;
    }
    .left {
      @media (${maxXs}) {
        align-items: center;
      }
      @media (${minXs}) {
        margin-right: 65px;
      }
    }

    h1 {
      width: 541px;
      white-space: pre-wrap;
      @media (${maxXs}) {
        width: 334px;
      }
    }

    span {
      width: 480px;
      margin-top: 20px;
      margin-bottom: 20px;

      @media (${maxXs}) {
        margin-top: 10px;
        width: 304px;
      }
    }

    img {
      width: 552px;
      object-fit: contain;

      @media (${maxXs}) {
        margin-top: 40px;
        width: 334px;
      }
    }

    @media (${maxXs}) {
      margin-top: 60px;

      flex-direction: column;
      justify-content: center;
      align-items: center;

      margin-right: 0px;
    }
  }

  .client-logos {
    img {
      width: 1132px;
      object-fit: contain;
    }

    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 135px;

    @media (${maxXs}) {
      display: none;
    }
  }

  .client-logos-mobile {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    img {
      width: 334px;
      object-fit: contain;
    }

    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;

    @media (${minXs}) {
      display: none;
    }
  }

  .products-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #f0f9fb80;

    .left {
      margin-right: 83px;
      @media (${maxXs}) {
        margin-right: unset;
      }
    }

    p {
      width: 400px;
      margin-top: 10px;
    }

    @media (${maxXs}) {
      .img-container {
        align-items: center;
      }
    }

    button {
      width: 180px;
      height: 36px;

      span {
        font-family: proxima-nova;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
      }
    }

    div.heading {
      align-items: center;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h1 {
        text-align: center;
        margin-top: 120px;
        width: 554px;

        @media (${maxXs}) {
          margin-top: 60px;
          width: 334px;
        }
      }

      span.description {
        margin-top: 20px;
        text-align: center;
        width: 484px;

        @media (${maxXs}) {
          margin-top: 10px;
          width: 304px;
        }
      }

      img {
        width: 460px;

        @media (${maxXs}) {
          margin-top: 20px;
          width: 332px;
        }
      }
    }

    .products-3d-desktop {
      margin-top: 130px;

      display: flex;
      flex-direction: row;

      @media (${maxXs}) {
        margin-top: 60px;
        flex-direction: column;
        h3 {
          width: 148px;
        }
        p {
          width: 304px;
        }
      }
    }

    .products-ar {
      display: flex;
      flex-direction: row;

      img {
        height: 343px;
        object-fit: contain;

        @media (${maxXs}) {
          height: 240px;
        }
      }

      @media (${maxXs}) {
        flex-direction: column;
        h3 {
          width: 208px;
        }
        p {
          width: 334px;
        }
      }
    }

    .products-new {
      display: flex;
      flex-direction: row;

      img {
        height: 281px;
        object-fit: contain;
      }

      button {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      @media (${maxXs}) {
        flex-direction: column;

        p {
          width: 324px;
        }

        img {
          margin-top: 20px;
          margin-bottom: 60px;
          height: unset;
        }
      }

      @media (${maxXs}) {
        margin-bottom: 0px !important;
      }
    }

    .products {
      margin-bottom: 140px;

      @media (${maxXs}) {
        margin-bottom: 60px;
      }
    }
  }

  .cases-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    margin-bottom: 154px;

    @media (${maxXs}) {
      margin-bottom: 60px;
    }

    .title {
      text-align: center;
      width: 518px;
      margin-bottom: 104px;

      @media (${maxXs}) {
        margin-bottom: 60px;
      }

      h1 {
        text-align: center;
        margin-bottom: 20px;
        margin-top: 120px;

        @media (${maxXs}) {
          margin-top: 60px;
        }
      }

      @media (${maxXs}) {
        width: 296px;
      }
    }

    .background {
      width: 698px;
      background: url(${background2});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;

      @media (${maxXs}) {
        padding-left: 20px;
        padding-right: 20px;
      }

      img {
        width: 123px;
        margin-bottom: 23px;
        object-fit: contain;
      }

      .text {
        text-align: center;
        margin-bottom: 11px;
        line-height: 2.5;

        @media (${maxXs}) {
          text-align: left;
          line-height: 1.23;
        }

        .quotes {
          font-size: 42px;
          line-height: 0.5;
          @media (${maxXs}) {
            font-size: 24px;
          }
        }
      }

      .person {
        display: flex;
        flex-direction: column;

        span {
          text-align: end;
        }
      }

      @media (${maxXs}) {
        width: 354px;
      }
    }

    .cta {
      display: flex;
      justify-content: center;

      button {
        width: 155px;
        margin-top: 10px;

        a {
          text-decoration: none;
          width: 100%;
        }
      }
    }
  }

  .bottomline-section {
    @media (${maxXs}) {
      padding-left: 20px;
      padding-right: 20px;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff5e6;

    .title {
      margin-top: 120px;
      width: 514px;
      text-align: center;

      @media (${maxXs}) {
        margin-top: 60px;
        width: 338px;
      }

      h1 {
        text-align: center;
        margin-bottom: 10px;

        @media (${minXs}) {
          display: none;
        }
      }
      h2 {
        margin-left: 31px;
        margin-right: 31px;
        text-align: center;
        margin-bottom: 20px;

        @media (${maxXs}) {
          display: none;
        }
      }
      span {
        font-size: 18px;
      }
    }

    hr {
      align-self: center;
      max-width: 1132px;
      width: 100%;
      height: 0;
      opacity: 0.2;
      border: solid 0.5px #222222;
      margin-top: 120px;

      @media (${maxXs}) {
        margin-top: 60px;
        width: 100%;
      }
    }
  }
`
